// removed by extract-text-webpack-plugin
module.exports = {"serviceSection":"src-components-Page----TechnologiesWeb-module---serviceSection---Y7RKv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/TechnologiesWeb.module.scss
// module id = 424
// module chunks = 77045900137884